import { UserProfileResponse } from './types'

export const initialUserProfileState: UserProfileResponse = {
  currentUserData: [
    {
      profile: {
        profileCompletion: {
          applied_one_plus_job: false,
          confirmed_account: false,
          set_any_education: false,
          set_any_job_preferences: false,
          set_any_position: false,
          set_full_name: false,
          verified_phone_number: false,
        },
      },
    },
  ],
}
